type SIRBadgeProps = {
  size?: 'sm' | 'md';
};

const sizeClasses: Record<NonNullable<SIRBadgeProps['size']>, string> = {
  sm: 'px-1.5 py-0.5 text-[10px]',
  md: 'px-3 py-2 text-sm',
};

export function SIRBadge({ size = 'md' }: SIRBadgeProps) {
  return (
    <span
      className={`${sizeClasses[size]} border border-solid border-gray-800 font-bold bg-orange-300 dark:bg-orange-400 text-xtnd-dark dark:text-xtnd-light`}
    >
      SIR
    </span>
  );
}

export default SIRBadge;
